/*eslint no-console: 0*/

import isTouchDevice from './isTouchDevice';

class Navigation {

  constructor(opts) {
    this.$el        = opts.$el;
    this.$toggler   = opts.$toggler;

    this.$navItems          = this.$el.find(".nav-item");
    this.$filteredNavItems  = this.$navItems.filter(":not("+opts.excludeWatch.join()+")");

    this.loadEvents();
  }

  reset() {
    this.$navItems.removeClass('-hover -expanded');
  }

  loadEvents() {
    let self = this;

    $(document).on('click', function(e) {
        if (!self.$navItems.is(e.target) && self.$navItems.has(e.target).length === 0) {
          self.$navItems.removeClass('-hover -expanded');
        }
    });

    this.$toggler.on('click', function() {
      this.$navItems.removeClass('-hover -expanded');
    }.bind(this));

    this.$filteredNavItems
      .on('ontouchstart', function() {
        $(this).addClass('-hover');
      })
      .on('mouseover', function() {
        if ($(window).width() >= 992)
          $(this).addClass('-hover');
      })
      .on('mouseout', function() {
        $(this).removeClass('-hover');
      });

    this.$navItems.filter(".dropdown").on('click', function(e) {
      e.stopPropagation();

      if (!$(this).hasClass('-expanded') && (isTouchDevice() || $(window).width() < 992))
        e.preventDefault();

      self.$navItems.find('.dropdown').removeClass('-expanded');
      $(this).siblings().removeClass('-hover -expanded');
      $(this).addClass('-expanded');
    });
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./scripts/util/Navigation.js